export default class LocationError extends Error {
  constructor(...args: any[]) {
    super(...args);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, LocationError);
    }
  }
}
